<template>
  <v-dialog
    v-model="getModalListarGradeProduto"
    persistent
    max-width="1020px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        Grades
      </v-card-title>
      <v-card-text>
        <Listar
          :botaoAdicionarVenda="botaoAdicionarVenda"
          :botaoAdicionarProduto="botaoAdicionarProduto"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          @click="setModalListarGradeProduto(false)"
          >Voltar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Listar from "@/pages/produto/grade/Listar";
export default {
  props: {
    botaoAdicionarVenda: false,
    botaoAdicionarProduto: false,
  },
  components: {
    Listar,
  },
  watch: {
    getProdutoVenda() {
      if (this.getProdutoVenda.id) {
        if (
          this.getProdutoVenda.grades.length > 0 &&
          this.getModalListarGradeProduto == false
        ) {
          this.setModalListarGradeProduto(true);
          this.$store.commit("setGradesProduto", this.getProdutoVenda.grades);
        }
      }
    },
    getProduto() {
      if (this.getProduto.id) {
        if (
          this.getProduto.grades.length > 0 &&
          this.getModalListarGradeProduto == false
        ) {
          this.setModalListarGradeProduto(true);
          this.$store.commit("setGradesProduto", this.getProduto.grades);
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "getModalListarGradeProduto",
      "getProdutoVenda",
      "getProduto",
    ]),
  },
  methods: {
    ...mapActions(["setModalListarGradeProduto", "listarGradeProduto"]),
  },
};
</script>
